module.exports = __webpack_public_path__ + "static/our-products-35ad55a1fff163a57cb7deeb367e620d.jpg";